/**
 * external libs
 */
import React from 'react'
/**
 * components
 */
import Widget from "../../../../Widget";
import Avatar from "../../../../Avatar";

/**
 * external libs
 */
import styles from './index.module.scss'
import WidgetString from "../../../../Widget/components/WidgetString";

export default function AvatarItem({ avatarResult, firstName, lastName , fontSize}) {
    return (
        <div className={styles.user}>
            <div className={styles.user__avatar}>
                <Avatar 
                    avatarResult={avatarResult} 
                    field={"url"}
                    firstName={firstName}
                    lastName={lastName}
                    fontSize={"28px"}
                />
            </div>
        </div>
    );
}
